import { render } from "./TalkToMyDataInvocations.vue?vue&type=template&id=7b9d028d&scoped=true"
import script from "./TalkToMyDataInvocations.vue?vue&type=script&lang=js"
export * from "./TalkToMyDataInvocations.vue?vue&type=script&lang=js"

import "./TalkToMyDataInvocations.vue?vue&type=style&index=0&id=7b9d028d&scoped=true&lang=css"
import "./TalkToMyDataInvocations.vue?vue&type=style&index=1&id=7b9d028d&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b9d028d"]])

export default __exports__